import { capitalize } from 'lodash'
export const makeUserFullName = (user = {}) => {
  if (!user) {
    return 'Utilisateur Supprimé'
  }
  return `${capitalize(user?.prenom)} ${capitalize(user?.nom)}`
}
